import { useEffect } from "react";
import { Globe } from "lucide-react";
import { LANGS, useT } from "@/lib/i18n";

export const LanguagePicker = ({ className = "" }) => {
  const { lang, setLang, t } = useT();

  useEffect(() => {
    document.documentElement.lang = lang;
    return () => { document.documentElement.lang = "en"; };
  }, [lang]);

  return (
    <label className={`relative inline-flex items-center gap-1.5 shrink-0 bg-white/90 backdrop-blur text-[#1F1D1B] text-sm font-semibold rounded-full px-3 py-1.5 shadow cursor-pointer ${className}`}>
      <Globe className="h-4 w-4 text-[#6B6560]" />
      <span data-testid="language-picker-code">{lang.toUpperCase()}</span>
      <select data-testid="language-picker" aria-label={t("language")} value={lang} onChange={(e) => setLang(e.target.value)} className="absolute inset-0 opacity-0 cursor-pointer">
        {LANGS.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
      </select>
    </label>
  );
};
